<template>
  <el-tabs
    v-model="pageCurrent"
    type="card"
    closable
    @tab-click="tabChange"
    @tab-remove="removeTab"
  >
    <el-tab-pane
      v-for="item in pageList"
      :key="item.path"
      :name="item.path"
    >
      <span slot="label">
        <span>{{ item.name }}</span>
        <!-- <span class="refresh"> -->
        <!-- <i style="font-size:15px;" @click="refreshModule(item)" class="el-icon-refresh" ></i> -->
        <!-- </span> -->
      </span>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import menuConfig from '@/config/menuConfig';

const menuToList = (menu) => {
  const newMenu = [];
  menu.forEach((item) => {
    newMenu.push(item);
    if (item.children) {
      newMenu.push(...menuToList(item.children));
    }
  });
  return newMenu;
};

export default {
  data() {
    return {
      pageCurrent: '',
      pageList: [
        {
          name: this.$t('router.Home'),
          path: '/index',
        },
      ],
      exclude: null,
      condition: true,
      menuList: menuToList(menuConfig),
    };
  },

  watch: {
    $route: {
      handler(to) {
        // 当路由改变时，检测该路由是否已经在打开的页面之中，如果不在，就添加进去
        this.pageCurrent = to.path;
        let matchPage = null;
        matchPage = this.pageList.find((page) => {
          return page.path === this.pageCurrent;
        });
        if (matchPage) return;

        matchPage = this.menuList.find((page) => {
          return page.path === this.pageCurrent;
        });
        if (!matchPage) matchPage = { name: to.name, path: to.path };
        if (matchPage) this.pageList.push(matchPage);
      },
      immediate: true,
    },
  },

  methods: {
    removeTab(targetPath) {
      const tabs = this.pageList;
      let activePath = this.pageCurrent;
      if (activePath === targetPath) {
        tabs.forEach((tab, index) => {
          if (tab.path === targetPath) {
            const nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activePath = nextTab.path;
            }
          }
        });
      }
      this.pageCurrent = activePath;
      this.pageList = tabs.filter(tab => tab.path !== targetPath);
      this.$router.push({ path: activePath });
    },
    tabChange(tab) {
      this.$router.push({ path: tab.path });
    },
    refreshModule() {
      // this.exclude = this.$refs.view.$options.name;
      // this.condition = !this.condition;
      // this.$nextTick(() => {
      //   this.exclude = null;
      //   this.condition = !this.condition;
      // });
    },
  },
};
</script>

<style lang="scss" sscoped>
.el-tabs__header {
  margin-bottom: 0;
}
</style>
<style lang="scss">
.el-tabs--card
  > .el-tabs__header
  .el-tabs__item.is-active.is-closable:first-child
  .el-icon-close,
.el-tabs--card
  > .el-tabs__header
  .el-tabs__item.is-closable:first-child:hover
  .el-icon-close {
  width: 0 !important;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-closable:first-child:hover {
  padding: 0 20px;
}
</style>
